
import axios from 'axios';
import MProgress from '../components/progress'
import { toast } from 'react-toastify';
import { url } from '../config/ips';

var allurl = ''
const instance = axios.create({
    baseURL: 'https://ningcat.com/',//'https://xudaxianer.cn',////
    timeout: 10000,
    // headers: { 'X-Custom-Header': 'foobar' }
});

//请求拦截处理
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    MProgress.start();
    allurl = config.url
   
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

//返回拦截处理
instance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    MProgress.done();
    return response;
}, function (error) {
    // 对响应错误做点什么
    MProgress.done();
    if (!error.response) {
        if (error.message.indexOf("timeout") > -1) {
            toast.warning("链接请求超时")
        } else {
            toast.warning("网络错误，请检查网络")
        }
    } else {
        switch (error.response.status) {
            case 400:
                toast.warning("错误请求")
                break;
            case 403:
                toast.warning("拒绝访问")
                break;
            case 404:
                toast.warning("请求错误，未找到该资源")
                break;
            case 408:
                toast.warning("请求超时")
                break;
            case 500:
                toast.warning("服务器端出错")
                break;
            case 501:
                toast.warning("网络未实现")
                break;
            case 502:
                toast.warning("网络错误")
                break;
            case 503:
                toast.warning("服务不可用")
                break;
            case 504:
                toast.warning("网络超时")
                break;
            default:
                toast.warning(`连接错误${error.response.status}`)
                break;
        }
    }

    
    return Promise.reject(error);
});


export const NetPost = async (api, params) => {
            return new Promise((resolve, reject) => {
                
                instance.post(api, params)
                    .then(res => {
                        resolve(res.data)
                    })
                    .catch(error => {
                        console.log("error", error)
                        reject(error)
                    })
            })
}


export const NetGet = async (api, params) => {

    return new Promise((resolve, reject) => {
        
        instance.get(api, {params:params})
            .then(res => {
                resolve(res.data)
            })
            .catch(error => {
                console.log("error", error)
                reject(error)
            })
    })


}




